import { FilterGroup } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../types';
import { getFundsMaturityFilter } from './fundsMaturity';

export const getFinanceGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'FINANCE',
    filters: [getFundsMaturityFilter(props)],
  };
};
